import { render, staticRenderFns } from "./AlertOneAddress.vue?vue&type=template&id=3bbe018b"
import script from "./AlertOneAddress.vue?vue&type=script&lang=js"
export * from "./AlertOneAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports